import { useGetCollectivesTreeSuspense } from "@/orval/gen"
import { TreePillsInput } from "../tree/tree-pills-input"
import { useTranslation } from "react-i18next"

interface CollectiveTreeSelectProps {
  value?: string[] | null | undefined
  onChange?: (value: string[]) => void
}

export function CollectiveTreeSelect({
  value,
  onChange,
}: CollectiveTreeSelectProps) {
  const { data: collectiveTree } = useGetCollectivesTreeSuspense()
  const { t } = useTranslation("app_server")
  return (
    <TreePillsInput
      initialCheckedState={value ?? []}
      tree={collectiveTree.tree}
      label={t("Collectives")}
      onCheckedStateChange={onChange}
    />
  )
}
